import { render, staticRenderFns } from "./ImageMagnifier.vue?vue&type=template&id=25fb9dd8&scoped=true"
import script from "./ImageMagnifier.vue?vue&type=script&lang=js"
export * from "./ImageMagnifier.vue?vue&type=script&lang=js"
import style0 from "./ImageMagnifier.vue?vue&type=style&index=0&id=25fb9dd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fb9dd8",
  null
  
)

export default component.exports